export class BookerInfoModel {
    userId: Number;
    visitorId: Number = 1;
    memberId: Number;
    companyId: Number;
    fullName: string;
    firstName: string;
    lastName: string;
    email: string;
    mobileNumber: string;
    typeOfTravelObjective: Number;
    typeOfTravel: Number = 1;
    countryISO2: string;
    countryCallingCode: string;
}

export class BookerInfo {
    bookerCurrency: string;
    fullName: string;
    firstName: string;
    lastName: string;
    mobileNumber: string;
    email?: string;
    countryISO2: string;
    countryCallingCode: string;
}



// WEBPACK FOOTER //
// ./src/app/model/checkout/booker-info.model.ts